import React from "react";
import { Modal, Button, Flex } from "@jsq/ds/core";
import { DefaultModalProps } from "./types";

export const DefaultModal: React.FC<DefaultModalProps> = ({
  show,
  title,
  body,
  modalSize = "small",
  posBtnVariant = "primary",
  posBtnText = "Continue",
  negBtnText = "Close",
  onClose,
  onConfirm,
}) => {
  return (
    <Modal show={show} size={modalSize}>
      <Modal.Header closeButton onHide={onClose}>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>{body}</Modal.Body>
      <Modal.Footer>
        <Flex flexDirection="row" gap="10px" justifyContent="flex-end">
          <Button variant="neutral" onClick={onClose}>
            {negBtnText}
          </Button>
          <Button variant={posBtnVariant} onClick={onConfirm}>
            {posBtnText}
          </Button>
        </Flex>
      </Modal.Footer>
    </Modal>
  );
};
